import { Add } from "@mui/icons-material";
import { Button, Paper } from "@mui/material";
import PaperButton from "components/buttons/PaperButton";
import CustomTab from "components/CustomTab";
import { ERR_NETWORK } from "constants/messages";
import { serverPost } from "lib/serverRequest";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import DeliveryZoneForm from "./DeliveryZoneForm";
import ShippingRatesTable from "./ShippingRatesTable";
import ShipptingRateForm from "./ShipptingRateForm";

export default function DeliveryZoneDetailComponent({ deliveryZone = {} }) {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const formRef = useRef();
  const shippingRef = useRef();
  const [shippingData, setShippingData] = useState({});
  const [addShipping, setAddShipping] = useState(false);
  const [data, setData] = useState({});

  const [activeTab, setActiveTab] = useState({
    label: "Postcodes",
    tab: "codes",
  });

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };

  const handleAdd = () => {
    const submitData = formRef.current.prepare();
    if (submitData) {
      serverPost({
        url: Boolean(data?.id) ? "deliveryZone/update" : "deliveryZone/create",
        data: { ...submitData, status: submitData?.status || "1" },
        onFinish: (res, err) => {
          if (res === false) {
            errorAction(res, err);
            return;
          }
          enqueueSnackbar(
            `Delivery zone ${data?.id ? "Updated" : "Added"} successfully.`,
            {
              variant: "success",
            }
          );
          history.goBack();
        },
      });
    }
  };
  const handleView = () => {};
  const handleAddShipping = () => {
    setAddShipping(true);
  };

  const handleAddRate = () => {};

  useEffect(() => {
    setData(deliveryZone);
  }, [deliveryZone]);

  return (
    <div>
      <div className="flex justify-between items-center">
        <CustomTab
          tabs={[
            { label: "Postcodes", tab: "codes" },
            { label: "Shipping Rates", tab: "rates" },
          ]}
          activeTab={activeTab}
          onClick={(tabItem) => {
            setActiveTab(tabItem);
            setAddShipping(false);
          }}
        />
        {activeTab?.tab === "rates" && (
          <PaperButton
            onClick={handleAddShipping}
            icon={<Add className="text-light-gray" />}
          >
            Add New Rate
          </PaperButton>
        )}
      </div>
      <Paper>
        {addShipping ? (
          <div className="p-4">
            <ShipptingRateForm
              data={shippingData}
              onChange={setShippingData}
              ref={shippingRef}
            />
          </div>
        ) : activeTab?.tab === "codes" ? (
          <div className="p-4">
            <DeliveryZoneForm data={data} onChange={setData} ref={formRef} />
          </div>
        ) : (
          <ShippingRatesTable data={data} onView={handleView} />
        )}
      </Paper>
      {activeTab?.tab === "codes" && (
        <div className="flex items-center my-4">
          <Button variant="contained" color="secondary" onClick={handleAdd}>
            {Boolean(data.id) ? "UPDATE" : "ADD"} DELIVERY ZONE
          </Button>
          <Button
            className="mx-2"
            variant="outlined"
            color="secondary"
            onClick={() => history.goBack()}
          >
            CANCEL
          </Button>
        </div>
      )}
      {addShipping && (
        <div className="flex items-center my-4">
          <Button variant="contained" color="secondary" onClick={handleAddRate}>
            CREATE NEW RATE
          </Button>
          <Button className="mx-2" variant="outlined" color="secondary">
            CANCEL
          </Button>
        </div>
      )}
    </div>
  );
}
